var symphony = symphony || {};

;
(function () {

	symphony.sharePopup = function (network, el) {

		var winTop = (screen.height / 2) - (350 / 2);
		var winLeft = (screen.width / 2) - (520 / 2);
		var shareUrl;
		var url = encodeURIComponent(window.location.href);
		var headline = encodeURIComponent($.trim($(el).parent().parent().find('p:first-of-type').text()));
		var title = encodeURIComponent($.trim($(el).parent().parent().find('.shareCard-stat').text()));
		var descr = encodeURIComponent($.trim($(el).parent().parent().find('.shareCard-cta').text()));
		var image = $('.rowStory-photo img').attr('src') || $('.rowStory-photo img').data('src');

		if (headline === "") {
			headline = document.title;
		}

		switch (network) {
			case "Facebook":
				FB.ui({
					method: 'share',
					mobile_iframe: true,
					href: window.location.href,
				}, function (response) {});
				return;
			case "Pinterest":
				shareUrl = 'https://pinterest.com/pin/create/button/?url=' + url + '&media=' + image + '&description=' + descr;
				break;
			case "Twitter":
				shareUrl = 'https://twitter.com/intent/tweet?text=' + headline + ' ' + url + ' ' + socialHandle_twitter;
				break;
			case "AddThis":
				var clickedIcon = el;
				$(clickedIcon).parent('li').toggleClass('isClicked');
				$(clickedIcon).next('.addthis_sharing_toolbox').toggleClass('isVisible');

				return;
		}

		window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=520,height=350');

	};

	symphony.sharePopupKey = function (network, el, e) {
		e = e || window.event;
		if (e && e.keyCode == 13) {
			symphony.sharePopup(network, el);
		}
	};

})();
